import { Button, Stack, Typography } from '@mui/material'

import { WelcomeDialogContent, WelcomeDialogueStyle } from '@/components/WelcomeDialogue/WelcomeDialogue.styled'
import { useMedia } from '@/hooks/useMedia'
import { useSiteContext } from '@/hooks/useSiteContext'
import { useTenant } from '@/hooks/useTenant'
import { useTranslations } from '@/hooks/useTranslations'
import { getTenantMarkets } from '@/lib/tenant/getTenantMarkets'

import type * as React from 'react'

interface WelcomeDialogueProps {
  openWelcome: boolean
}

export const WelcomeDialogue: React.FC<WelcomeDialogueProps> = ({ openWelcome }) => {
  const { translate } = useTranslations()
  const { setSiteContext } = useSiteContext()
  const tenant = useTenant()
  const { isMobile } = useMedia()

  const tenantSites = getTenantMarkets(tenant.id)

  return (
    <WelcomeDialogueStyle disableEscapeKeyDown fullWidth open={openWelcome}>
      <WelcomeDialogContent>
        <Stack spacing={2}>
          <Typography component="h2" variant="h3" color="secondary">
            {translate('welcome.title')}
          </Typography>
          <Typography component="p" variant="body1">
            {translate('welcome.subtitle')}
          </Typography>
          <Stack gap={1.5} flexDirection={isMobile ? 'column' : 'row'}>
            {tenantSites.map((site) => {
              return (
                <Stack width="100%" key={site}>
                  <Button
                    fullWidth
                    size="large"
                    onClick={() => setSiteContext(site)}
                    variant="outlinedFocused"
                    data-testid={`welcomeDialogue-${site}Button`}
                  >
                    {translate(`welcome.${site}Button`)}
                  </Button>
                  <Typography component="p" variant="body1">
                    {translate(`welcome.${site}Text`)}
                  </Typography>
                </Stack>
              )
            })}
          </Stack>
        </Stack>
      </WelcomeDialogContent>
    </WelcomeDialogueStyle>
  )
}
